module.exports = __webpack_public_path__ + "img/legend-logo.90ba6d24.svg";